import React, { Component } from 'react';
import {connect} from 'react-redux'
import AccountInfo from '../../../containers/authorised/patientPartials/AccountInformationPartial'
import SocialHistory from '../../../containers/authorised/appointment/SocialHistory'
import MedicalHistory from '../../../containers/authorised/appointment/MedicalHistory'
import ReviewOfSystem from '../../../containers/authorised/appointment/ReviewOfSystem'
import Document from '../../../containers/authorised/appointment/Documents'

import { patientSocialHistoriesLoad} from '../../../redux/actions/patient/patientSocialHistoryActions';
import {socialHistoriesLoad as settingSocialHistoriesLoad } from '../../../itrust_common/redux/actions/settingActions/socialHistoryActions';
import {patientMedicalHistoriesLoad} from '../../../redux/actions/patient/patientMedicalHistoryActions';
import {patientReviewOfSystemsLoad} from '../../../redux/actions/patient/patientReviewOfSystemActions';
import {reviewOfSystemsLoad} from '../../../itrust_common/redux/actions/settingActions/reviewOfSystemActions';
import {patientDocumentsLoad} from '../../../redux/actions/patient/patientDocumentActions';
import { initializePatientTemplateAttributes } from '../../../itrust_common/components/HelperFunctions';
import { patientEdit } from '../../../redux/actions/patient/patientActions';

class PatientDetailsForm extends Component{

  handleSocialHistoryLoad(){
    this.props.dispatch(settingSocialHistoriesLoad({sort: 'category, position'}));
    this.props.dispatch(patientSocialHistoriesLoad(this.props.patient.id));
  }
  handleMedicalHistoryLoad(){
    this.props.dispatch(patientMedicalHistoriesLoad(this.props.patient.id));
  }
  handleReviewOfSystemLoad(){
    this.props.dispatch(reviewOfSystemsLoad({rpp: 9999999}))
    this.props.dispatch(patientReviewOfSystemsLoad(this.props.patient.id));
  }
  handleDocumentsLoad(){
    this.props.dispatch(patientDocumentsLoad(this.props.patient.id, {include: ['document', 'tags']}));
  }

  componentDidMount(){
    if(this.props.formType === "new"){
      var patientData = initializePatientTemplateAttributes(this.props.patientTemplate.personal_information)
      this.props.dispatch(patientEdit(this.props.patient.id, patientData));
    }
  }

  render(){
    const { patient, isQuickAction, wrapperClasses } = this.props;
    return (
      <div className="w-75 overflow-auto" style={{minHeight: '58.5rem'}}>
        <div className={`fixed-container-modal px-5 bg-light pt-9 w-75 ${wrapperClasses}`}>
          <div className="d-flex flex-row align-items-center justify-content-between">
            <h5>Patient Details</h5>
          </div>
          <div className="border-bottom border-light">
            <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item">
                <a className="py-5 pl-0 pr-7 tab-link active" id="account-info-tab" data-toggle="tab" href="#account-info" role="tab" aria-controls="account-info" aria-selected="true">
                  Account information
                </a>
              </li>
              {
                patient &&
                [<li className="nav-item">
                  <a className={`py-5 pl-0 pr-7 tab-link ${!patient.id && 'disabled'}`} id="social-history-tab" data-toggle="tab" href="#social-history" role="tab" aria-controls="social-history" aria-selected="false" onClick={()=> this.handleSocialHistoryLoad() }>
                    Social History
                  </a>
                </li>,
                <li className="nav-item">
                  <a className={`py-5 pl-0 pr-7 tab-link ${!patient.id && 'disabled'}`} id="medical-history-tab" data-toggle="tab" href="#medical-history" role="tab" aria-controls="medical-history" aria-selected="false" onClick={()=> this.handleMedicalHistoryLoad() }>
                    Medical History
                  </a>
                </li>,
                <li className="nav-item">
                  <a className={`py-5 pl-0 pr-7 tab-link ${!patient.id && 'disabled'}`} id="review-of-system-tab" data-toggle="tab" href="#review-of-system" role="tab" aria-controls="review-of-system" aria-selected="false" onClick={()=> this.handleReviewOfSystemLoad() }>
                    Review Of Systems
                  </a>
                </li>,
                <li className="nav-item">
                  <a className={`py-5 pl-0 pr-7 tab-link ${!patient.id && 'disabled'}`} id="document-tab" data-toggle="tab" href="#document" role="tab" aria-controls="document" aria-selected="false" onClick={()=> this.handleDocumentsLoad() }>
                    Attached Docs
                  </a>
                </li>
                ]}
            </ul>
          </div>
        </div>
        <div className="middle-container-modal px-5 mb-9">
          <div className="tab-content">
            <div className="tab-pane active" id="account-info" role="tabpanel" aria-labelledby="account-info-tab">
              <AccountInfo isQuickAction={isQuickAction} />
            </div>
            {
              patient && patient.id &&
              [<div className="tab-pane" id="social-history" role="tabpanel" aria-labelledby="social-history-tab">
                <SocialHistory patientId={patient.id} />
              </div>,
              <div className="tab-pane" id="medical-history" role="tabpanel" aria-labelledby="medical-history-tab">
                <MedicalHistory patientId={patient.id}/>
              </div>,
              <div className="tab-pane" id="review-of-system" role="tabpanel" aria-labelledby="review-of-system-tab">
                <ReviewOfSystem patientId={patient.id}/>
              </div>,
              <div className="tab-pane" id="document" role="tabpanel" aria-labelledby="document-tab">
                <Document patientId={patient.id}/>
              </div>]
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {patient, setting, appointment} = state
  return {
    patient: patient.patient,
    formType: appointment.handlerData.formType,
    patientTemplate: setting.patientTemplate.patient_template
  }
}
export default connect(mapStateToProps)(PatientDetailsForm);
